import { IEmailTemplate, IContactEntityType, IEmail, IEmailTemplatePreview, IEmailAddressField } from "../../../models"

export interface IEmailTemplateState {
    list: IEmailTemplate[];
    sendeeList: {
        emailAddressFields: IEmailAddressField[],
        contactEntityTypes: IContactEntityType[]
    },
    emailTags: IEmail[];
    emailPreview: IEmailTemplatePreview;
}